import { render, staticRenderFns } from "./CreateFixedDeposit.vue?vue&type=template&id=485f2661&scoped=true&"
import script from "./CreateFixedDeposit.vue?vue&type=script&lang=js&"
export * from "./CreateFixedDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f2661",
  null
  
)

export default component.exports